import React from "react";
import {
  Tr,
  Td,
  Flex,
  Text,
  Progress,
  Icon,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import Facebookico from "../../img/iconofacebook.png";
import Instagramico from "../../img/iconoinstagram.png";
import Whatsappico from "../../img/iconowhatsapp.png";
import UserDirect from "../../img/iconouser.png";

function DashboardTableRow(props) {
  const { logo, name, status, budget, progression, isLast, colorbarra } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  return (
    <Tr>
      <Td
        minWidth={{ sm: "250px" }}
        pl="0px"
        borderColor={borderColor}
        borderBottom={isLast ? "none" : null}
      >
        <Flex alignItems="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          {name == "Facebook" ? (
            <>
              <img src={Facebookico} width="32px" heigth="32px" /> &nbsp;&nbsp;
            </>
          ) : (
            <></>
          )}
          {name == "Instagram" ? (
            <>
              <img src={Instagramico} width="32px" heigth="32px" /> &nbsp;&nbsp;
            </>
          ) : (
            <></>
          )}
          {name == "Whatsapp" ? (
            <>
              <img src={Whatsappico} width="32px" heigth="32px" /> &nbsp;&nbsp;
            </>
          ) : (
            <></>
          )}
          {name == "Direct Link" ? (
            <>
              <img src={UserDirect} width="32px" heigth="32px" /> &nbsp;&nbsp;
            </>
          ) : (
            <></>
          )}
          <Text
            fontSize="md"
            color={titleColor}
            fontWeight="bold"
            minWidth="100%"
          >
            {name}
          </Text>
        </Flex>
      </Td>
      <Td borderBottom={isLast ? "none" : null} borderColor={borderColor}>
        <Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
          {budget}
        </Text>
      </Td>

      <Td borderBottom={isLast ? "none" : null} borderColor={borderColor}>
        <Flex direction="column">
          <Text
            fontSize="md"
            color="blue.500"
            fontWeight="bold"
            pb=".2rem"
          >{`${progression}%`}</Text>
          <Progress
            colorScheme={colorbarra}
            size="xs"
            value={progression}
            borderRadius="15px"
          />
        </Flex>
      </Td>
    </Tr>
  );
}

export default DashboardTableRow;
